import {ComponentInfo, PageInfo, PageWithSubPageInfo, PageWithSubPagesInfo, SubMenu} from '../../../typings/sdk';

export function getPageId(componentInfo: ComponentInfo, pages: PageWithSubPagesInfo[], currentPageId: string): string {
  if (!componentInfo.showOnAllPages) {
    return componentInfo.pageId;
  }
  const flattenedPages = flattenPages(pages);
  const mainPage = flattenedPages.filter((page) => page.isHomepage)[0];
  if (!mainPage) {
    throw new Error('Homepage not found');
  }
  if (mainPage.hide) {
    return currentPageId;
  }
  return mainPage.id;
}

function flattenPages(pages: PageWithSubPagesInfo[]): PageInfo[] {
  return pages
    .reduce((acc: PageInfo[], page: PageWithSubPagesInfo) => {
      return [
        ...acc,
        ...(isNavigablePage(page) ? [page] : []),
        ...(hasSubPages(page) ? flattenPages(page.subPages) : []),
      ];
    }, [] as PageInfo[])
    .filter(isNavigablePage);
}

function hasSubPages(page: PageWithSubPagesInfo): page is SubMenu | PageWithSubPageInfo {
  return page.hasOwnProperty('subPages') && Array.isArray((page as SubMenu | PageWithSubPageInfo).subPages);
}

function isNavigablePage(page: PageWithSubPagesInfo): page is PageInfo | PageWithSubPageInfo {
  return 'id' in page && Boolean(page.id);
}
